export default function InsightsAllowed() {
	if (Tools.AppService.getMetadata()?.params?.LookerDashboardExeptionIds) {
		return true;
	}
	return Tools.FeatureHelper.isAvailable(Tools.FeatureHelper.Feature.LOOKER);
}
